import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { GET_DEVICE } from "../../queries";
import { Alert } from "@mui/material";
import { useEffect } from "react";
interface WatchForNewJobProps {
	dataLoaded: (d: { countcDevice: Device; countcCountSummary: JobSummary }) => void;
	DeviceCommand: { ts: number; command: string };
}

const WatchForNewJob = ({ dataLoaded, DeviceCommand }: WatchForNewJobProps) => {
	let { id } = useParams();

	const { error, startPolling, stopPolling, refetch } = useQuery(GET_DEVICE, {
		variables: { DeviceID: Number(id) },
		onCompleted: dataLoaded,
		notifyOnNetworkStatusChange: true,
	});

	useEffect(() => {
		startPolling(60000);
		return () => {
			stopPolling();
		};
	}, [startPolling, stopPolling]);

	useEffect(() => {
		if (error) {
			console.log("WatchForNewJob useEffect error", error);
		}
	}, [error]);

	useEffect(() => {
		if (DeviceCommand && refetch) {
			setTimeout(() => {
			refetch();
			}, 1000);
		}
	}, [DeviceCommand, refetch]);

	return <>{error ? <Alert severity="warning">Job Info may not refresh if changed from another device.</Alert> : null}</>;
};

export default WatchForNewJob;
